// factories/IntegrationFactory.ts

import type { IntegrationInterface } from '../interfaces/IntegrationInterface'
import { OfhIntegration } from '../integrations/OfhIntegration'
import { SmsIntegration } from '../integrations/SmsIntegration'
import { GeotabIntegration } from '../integrations/GeotabIntegration'
import { defineAsyncComponent } from 'vue'

// Type for strategies with sendVerificationCode
export interface VerificationStrategy extends IntegrationInterface {
    sendVerificationCode(mobileNumber: string): Promise<any>
}

export class IntegrationFactory {
    static getStrategy(integrationName: string): IntegrationInterface {
        switch (integrationName) {
            case 'ofh':
                return new OfhIntegration()
            case 'sms':
                return new SmsIntegration()
            case 'geotab':
                return new GeotabIntegration()
            // Add other strategies...
            default:
                throw new Error('Unsupported integration type')
        }
    }

    static getLoginFormComponent(integrationName: string) {
        try {
            return defineAsyncComponent(
                () => import(`../components/integrations/${integrationName}/LoginForm.vue`)
            )
        } catch (error) {
            console.error('Component loading failed:', error)
            throw new Error('Component not found')
        }
    }

    // Helper method to get specifically a verification-capable strategy
    static getSmsStrategy(): VerificationStrategy {
        return new SmsIntegration() as VerificationStrategy
    }
}
